<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-header class="mb-0" header-bg-variant="transparent">
            <b-form @submit.prevent="fetchData">
                <b-form-group :label="$t('Search')">
                    <b-input-group>
                        <b-form-input v-model="search" />

                        <b-input-group-append>
                            <b-button type="submit">
                                <fa :title="$t('Search')" icon="search" />
                            </b-button>

                            <services-import-modal :project-id="projectId" />
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-form>
        </b-card-header>

        <b-card-body v-if="!pending && !items.length">
            <no-results-found class="mb-0" />
        </b-card-body>

        <b-list-group flush>
            <b-list-group-item
                v-for="(item, index) in items"
                :key="item.id"
            >
                <service-list-item
                    :api-url="apiUrl"
                    v-model="items[index]"
                    :id="item.id"
                    @deleted="fetchData"
                />
            </b-list-group-item>
        </b-list-group>

        <b-card-footer v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                class="m-0"
            />
        </b-card-footer>

        <router-view @created="fetchData" @input="fetchData"/>
    </div>
</template>

<script>
    import fetchPaginatedData from '@/mixins/fetchPaginatedData';
    import ServiceListItem from '@/components/project_services/ListItem';
    import ServicesImportModal from "@/components/projects/ServicesImportModal";
    import ProjectElementsListItem from "@/components/project_elements/ListItem.vue";

    export default {
        name: 'ProjectAvailableService',
        components: {ProjectElementsListItem, ServicesImportModal, ServiceListItem},
        mixins: [fetchPaginatedData],
        props: {
            projectId: {
                type: [Number, String],
                required: true,
            },
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/available_services`;
            },
        },
        created() {
            this.$root.$on('services-imported', this.fetchData)
        },
    };
</script>
